import { defineStore } from 'pinia';
import { store } from '@/app/stores';
import { ModalState } from '@/app/types/modals';

interface SystemState {
    modalState: ModalState;
    isSlowNetwork: boolean;
    pingTime: number;
}

export const useSystemStore = defineStore('app-system', {
    state: (): SystemState => ({
        modalState: {
            show: false,
            title: '',
            message: '',
            confirmEvent: null,
        },
        isSlowNetwork: false,
        pingTime: 0,
    }),
    getters: {
        getModalState(): ModalState {
            return this.modalState;
        },
        getIsSlowNetwork(): boolean {
            return this.isSlowNetwork;
        },
        getPingTime(): number {
            return this.pingTime;
        },
    },
    actions: {
        setIsSlowNetwork(isSlowNetwork: boolean) {
            this.isSlowNetwork = isSlowNetwork;
        },
        setPingTime(pingTime: number) {
            this.pingTime = pingTime;
        },
        setModalState(modalState: ModalState) {
            this.modalState = modalState;
        },
        hideModalState() {
            this.modalState.show = false;
            this.modalState.title = '';
            this.modalState.message = '';
            this.modalState.confirmEvent = null;
        },
    },
});

export function useSystemStoreWithOut() {
    return useSystemStore(store);
}
